import { useEffect } from "react";
import Lenis from "lenis";
import { motion } from "framer-motion";
import { Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { Sparkles, ArrowRight } from "lucide-react";
import "@/App.css";

import Nav from "@/components/sections/Nav";
import Footer from "@/components/sections/Footer";
import HomePage from "@/pages/HomePage";
import TheMothersFilm from "@/pages/TheMothersFilm";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App grain bg-sand">
      <Toaster position="top-center" richColors offset="70px" toastOptions={{ style: { fontFamily: "'Plus Jakarta Sans', sans-serif" } }} data-testid="apply-form-success-toast" />
      <motion.div
        data-testid="anniversary-film-banner"
        initial={{ y: -12, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="fixed top-0 inset-x-0 z-[60] h-12 flex items-center justify-center px-4 sm:gap-3 text-center text-sand shadow-[0_2px_20px_rgba(217,155,38,0.35)] group overflow-hidden"
        style={{ background: "linear-gradient(90deg, #8c5a12, #d99b26 25%, #e6c575 50%, #d99b26 75%, #8c5a12)", backgroundSize: "200% 100%", animation: "shimmer 6s linear infinite" }}
      >
        <Link to="/the-mothers-birthday-film" className="flex items-center gap-2 sm:gap-3 max-w-full">
          <motion.span animate={{ rotate: [0, 15, -10, 0], scale: [1, 1.15, 1] }} transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }} className="shrink-0">
            <Sparkles className="w-4 h-4 text-white drop-shadow shrink-0" />
          </motion.span>
          <span className="font-semibold text-[11px] sm:text-sm tracking-wide truncate drop-shadow-sm min-w-0">
            <span className="sm:hidden">The Mother's 150th Anniversary — new film</span>
            <span className="hidden sm:inline">Celebrating The Mother's 150th Birth Anniversary — a new feature film</span>
          </span>
          <span className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-ink/90 group-hover:bg-ink px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide shrink-0 transition-colors">
            Watch the story
            <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
          </span>
        </Link>
      </motion.div>
      <Nav />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/the-mothers-birthday-film" element={<TheMothersFilm />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;

